import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAdmin } from '../../contexts/AdminContext';

/**
 * The /admin index. Partners have no host/tenant dashboard — send them to their
 * portal. Everyone else gets the normal admin dashboard passed as children.
 */
const AdminIndexRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { isPartner } = useAdmin();
  if (isPartner) return <Navigate to="/admin/partner-portal" replace />;
  return <>{children}</>;
};

export default AdminIndexRoute;
